import React from 'react';
import { useToasterState } from 'services/toaster/useToasterState';
import { getSnackBarStyles, MessageToMarkdown } from './helpers';
import { Snackbar, SnackbarContent, Theme } from '@mui/material';

import { WithStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';

const styles = createStyles((theme: Theme) => ({
  root: {
    zIndex: 30000,
  },
  snackbar: {
    borderRadius: 5,
  },
  snackbarError: {
    borderRadius: 5,
    backgroundColor: 'indianred',
  },
  message: {
    margin: '0 auto',
    textAlign: 'center' as const,
    whiteSpace: 'pre-line' as const,
  },
  messageStrong: {
    color: theme.palette.primary.main,
  },
}));

const Toaster = ({ classes }: WithStyles<any>): JSX.Element | null => {
  const { visible, message, type, position } = useToasterState();

  return (
    <Snackbar
      open={visible}
      anchorOrigin={position}
      classes={{ root: classes.root }}
    >
      <SnackbarContent
        message={MessageToMarkdown(message!, classes)}
        classes={getSnackBarStyles(classes, type)}
      />
    </Snackbar>
  );
};

export default withStyles(styles)(Toaster);
